import {
  Client,
  ActuatorSettings,
  CommandSettings,
  GeneralCommandsAndGroupsAction,
  DefaultObjectAction,
  ObjectAction,
  WaitTimeAction,
  Action,
  Trigger,
  Condition,
  ObjectTrigger,
  ButtonTrigger,
  DateAndTimeTrigger,
  TimeCondition,
  ObjectCondition,
  ExtDevice,
  ColoredLightExtDevice,
  XmeterExtDevice,
  PlayerExtDevice,
} from '@/../client-generator/generated-clients/plants';
import axiosInstance from '../utils/axios-instance';

Condition.prototype.init 
= Trigger.prototype.init 
= Action.prototype.init 
= ActuatorSettings.prototype.init 
= CommandSettings.prototype.init 
= GeneralCommandsAndGroupsAction.prototype.init 
= DefaultObjectAction.prototype.init 
= ObjectAction.prototype.init 
= WaitTimeAction.prototype.init 
= ObjectTrigger.prototype.init 
= ButtonTrigger.prototype.init 
= DateAndTimeTrigger.prototype.init 
= TimeCondition.prototype.init 
= ObjectCondition.prototype.init
= ExtDevice.prototype.init
= ColoredLightExtDevice.prototype.init
= XmeterExtDevice.prototype.init
= PlayerExtDevice.prototype.init = function (
  data?: any
) {
  if (data) {
    for (var property in data) {
      if (Object.prototype.hasOwnProperty.call(data, property))
        (<any>this)[property] = (<any>data)[property];
    }
  }
};

Condition.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.Condition, ProtocolManager`,
    ...this,
  };
};
Trigger.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.Trigger, ProtocolManager`,
    ...this,
  };
};
Action.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.Action, ProtocolManager`,
    ...this,
  };
};
ActuatorSettings.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.ActuatorSettings, ProtocolManager`,
    ...this,
  };
};
CommandSettings.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.CommandSettings, ProtocolManager`,
    ...this,
  };
};
GeneralCommandsAndGroupsAction.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.GeneralCommandsAndGroupsAction, ProtocolManager`,
    ...this,
  };
};
DefaultObjectAction.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.DefaultObjectAction, ProtocolManager`,
    ...this,
  };
};
ObjectAction.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.ObjectAction, ProtocolManager`,
    ...this,
  };
};
WaitTimeAction.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.WaitTimeAction, ProtocolManager`,
    ...this,
  };
};
ObjectTrigger.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.ObjectTrigger, ProtocolManager`,
    ...this,
  };
};
ButtonTrigger.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.ButtonTrigger, ProtocolManager`,
    ...this,
  };
};
DateAndTimeTrigger.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.DateAndTimeTrigger, ProtocolManager`,
    ...this,
  };
};
TimeCondition.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.TimeCondition, ProtocolManager`,
    ...this,
  };
};
ObjectCondition.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.ObjectCondition, ProtocolManager`,
    ...this,
  };
};
ExtDevice.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.ExtDevice, ProtocolManager`,
    ...this,
  };
};
ColoredLightExtDevice.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.ColoredLightExtDevice, ProtocolManager`,
    ...this,
  };
};
XmeterExtDevice.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.XmeterExtDevice, ProtocolManager`,
    ...this,
  };
};
PlayerExtDevice.prototype.toJSON = function (data?: any) {
  return {
    $type: `ProtocolManager.Model.PlayerExtDevice, ProtocolManager`,
    ...this,
  };
};

const plantsClient = new Client('', axiosInstance);

export default plantsClient;
